import { readersAndIntercom } from '../product-list-groups/readersAndIntercom.mjs';
import { uaUltra } from './uaUltra.mjs';
"use strict";
const readerAccessUltra = {
  ...uaUltra,
  productListGroup: readersAndIntercom,
  propertyValues: [{
    propertyId: "dimensions",
    value: {
      type: "string",
      value: '126 x 45 x 37.45 mm\n(4.9 x 1.8 x 4.5")'
    }
  }, {
    propertyId: "cameraReader",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "twoWayIntercom",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "directory",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "touchPassSupport",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "pinAccess",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "nfcCard",
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: "mobileAppAccess",
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: "hand",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "outdoorReady",
    value: {
      type: "translation",
      value: "uaUltra.outdoorReady"
    }
  }, {
    propertyId: "readerPowerMethod",
    value: {
      type: "string",
      value: "PoE+"
    }
  }]
};
export { readerAccessUltra };
//# sourceMappingURL=readerAccessUltra.mjs.map
